export default __webpack_public_path__ + "static/CorprateHp_11-1a32852b51e1d9845a4e8b0d292d8bcb.jpg";